export function isContrast (hex?: string | null) {
  if (hex) {
    const rgb = hexToRgb(hex)
    if (rgb) {
      const linear = (v: number) => {
        v /= 255
        return v <= 0.03928
          ? v / 12.92
          : Math.pow((v + 0.055) / 1.055, 2.4)
      }
      const luminance = 0.2126 * linear(rgb.r) + 0.7152 * linear(rgb.g) + 0.0722 * linear(rgb.b)
      const contrastWithBlack = (luminance + 0.05) / 0.05
      const contrastWithWhite = 1.05 / (luminance + 0.05)
      return contrastWithBlack > contrastWithWhite
    }
  }
  return true
}

export function hexToRgb (hex: string): {
  r: number
  g: number
  b: number
} | null {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)
  return result
    ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
      }
    : null
}
